import React from 'react';
import { Link } from 'react-router-dom';
import { FiFileText, FiAlertCircle, FiCheckCircle, FiLock } from 'react-icons/fi';
import './Terms.css';

const Terms = () => {
  const sections = [
    {
      title: '1. Acceptance of Terms',
      content: 'By accessing or using the BASICK website and services, you agree to be bound by these Terms of Service. If you do not agree to all the terms and conditions, you may not access the website or use our services.'
    },
    {
      title: '2. Account Registration',
      content: 'To make purchases, you may need to create an account. You are responsible for maintaining the confidentiality of your account information and for all activities that occur under your account. You must be at least 18 years old to create an account.'
    },
    {
      title: '3. Products and Pricing',
      content: 'We strive to display accurate product information and pricing. However, errors may occur. We reserve the right to correct any errors and to change or update information at any time without prior notice. Prices are subject to change without notice.'
    },
    {
      title: '4. Orders and Payment',
      content: 'All orders are subject to acceptance and availability. We reserve the right to refuse or cancel any order for any reason, including limitations on quantities available for purchase, inaccuracies in product information, or issues identified by our fraud prevention team.'
    },
    {
      title: '5. Shipping and Delivery',
      content: 'Shipping times and costs are estimated and may vary. Risk of loss and title for items purchased pass to you upon delivery. We are not responsible for delays caused by carriers or customs.'
    },
    {
      title: '6. Returns and Refunds',
      content: 'Our return policy is outlined separately and incorporated into these Terms. Please refer to our Returns Policy for detailed information about returns and refunds.'
    },
    {
      title: '7. Intellectual Property',
      content: 'All content on this website, including images, text, logos, and designs, is the property of BASICK and protected by copyright and intellectual property laws. You may not reproduce, distribute, or create derivative works without our express written consent.'
    },
    {
      title: '8. Limitation of Liability',
      content: 'BASICK shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of our services or products.'
    },
    {
      title: '9. Governing Law',
      content: 'These Terms shall be governed by the laws of the State of New York, without regard to its conflict of law provisions.'
    },
    {
      title: '10. Changes to Terms',
      content: 'We reserve the right to modify these Terms at any time. Changes will be effective immediately upon posting. Your continued use of the website constitutes acceptance of the modified Terms.'
    }
  ];

  return (
    <div className="terms-page">
      {/* Hero Section */}
      <section className="terms-hero">
        <div className="container">
          <h1 className="terms-hero-title">Terms of Service</h1>
          <p className="terms-hero-description">
            Please read these terms carefully before using our services.
          </p>
          <p className="terms-last-updated">Effective Date: February 15, 2026</p>
        </div>
      </section>

      {/* Terms Content */}
      <section className="terms-content">
        <div className="container">
          <div className="terms-grid">
            <div className="terms-main">
              <div className="terms-intro">
                <FiFileText className="intro-icon" />
                <h2>Agreement Between User and BASICK</h2>
                <p>
                  Welcome to BASICK. These Terms of Service govern your use of our website, products, and services. 
                  By accessing or using BASICK, you agree to be bound by these Terms and our Privacy Policy.
                </p>
              </div>

              {sections.map((section, index) => (
                <div key={index} className="terms-section">
                  <h3>{section.title}</h3>
                  <p>{section.content}</p>
                </div>
              ))}

              <div className="terms-contact">
                <h3>Contact Information</h3>
                <p>
                  If you have any questions about these Terms, please contact us at:
                </p>
                <ul className="contact-info">
                  <li>BASICK Legal Department</li>
                  <li>200 Fifth Avenue</li>
                  <li>New York, NY 10010</li>
                  <li>Email: legal@basick.com</li>
                </ul>
              </div>
            </div>

            <div className="terms-sidebar">
              <div className="sidebar-box">
                <FiAlertCircle className="sidebar-icon" />
                <h3>Quick Summary</h3>
                <ul className="summary-list">
                  <li>You must be 18+ to create an account</li>
                  <li>Prices and availability subject to change</li>
                  <li>Orders may be canceled</li>
                  <li>Content is protected by copyright</li>
                  <li>Returns subject to our policy</li>
                </ul>
              </div>

              <div className="sidebar-box">
                <FiCheckCircle className="sidebar-icon" />
                <h3>Your Agreement</h3>
                <p>
                  By continuing to use our website, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service.
                </p>
              </div>

              <div className="sidebar-box">
                <FiLock className="sidebar-icon" />
                <h3>Related Policies</h3>
                <ul className="related-links">
                  <li><Link to="/privacy">Privacy Policy</Link></li>
                  <li><Link to="/returns">Returns Policy</Link></li>
                  <li><Link to="/shipping">Shipping Policy</Link></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Terms;